
export default {
    model: {
        event: "countEmit",
        prop: "count",
    },
    props: {
        /** The amount of animations - connected to countEmit emit  */
        count: {
            type: Number,
            default: 0,
        },
        /** List of objects representing the animations - connected to itemsEmit emit */
        items: {
            type: Array,
            default: () => [],
        },
        /** icon name */
        icon: {
            type: String,
            default: "chat",
        },
        /** Duration of the animation in ms */
        duration: {
            type: Number,
            default: 4000,
        },
        /** Positive & negative duraton spread in ms */
        durationSpread: {
            type: Number,
            default: 0,
        },
        /** Horizontal start point offset */
        xOffset: {
            type: Number,
            default: 150,
        },
        /** Vertical start point offset */
        yOffset: {
            type: Number,
            default: 150,
        },
        /** A custom class naming for the animations
         * By default, the classes are extended using "variation 1-5"
         */
        animationClass: {
            type: String,
            default: "",
        },
        /** Amount of different animations. Adding different numbers after the animation class by random (1-x)*/
        animationAmount: {
            type: Number,
            default: 3,
        },
        /** Animation icon color */
        color: {
            type: String,
            default: "red",
        },
    },
    data: () => {
        return {
            internalAnimations: [],
            internalCounter: 0,
            totalCounter: 0,
        }
    },
    emits: ["count", "items", "start", "end"],
    watch: {
        items(val) {
            let x = val.length - this.count
            for (; x > 0; x--) {
                this.sendEvent()
            }
        },
        count(val) {
            let x = val - this.internalCounter
            for (; x > 0; x--) {
                this.sendEvent()
            }
        },
    },
    methods: {
        /** Public interface for sending an event */
        sendEvent() {
            this.internalAnimations.push(this.totalCounter)
            this.$emit("start", this.totalCounter)
            let spread =
                this.randomBySeed(this.totalCounter) *
                    this.durationSpread *
                    1000 +
                this.duration
            setTimeout(() => {
                this.internalAnimations.shift()
                this.internalCounter--
                this.$emit("countEmit", this.count - 1)
                this.$emit("itemsEmit", [...this.items].shift())
                this.$emit("stop", this.totalCounter)
            }, this.duration + spread)
            this.internalCounter++
            this.totalCounter++
        },
        animationStyle(item) {
            let random = this.randomBySeed(item)
            let random2 = this.randomBySeed(item * item)
            return `
            margin-left: ${this.xOffset * random - this.xOffset / 2}px;
            margin-top: ${this.yOffset * random2 - this.yOffset / 2}px;
            animation: ${this.animationClass}${Math.ceil(
                random * this.animationAmount
            )} ${
                random * this.durationSpread + this.duration / 1000
            }s linear forwards;
            `
        },
        randomBySeed(seed) {
            let _seed = seed % 2147483647
            if (_seed <= 0) _seed += 2147483646
            _seed = (_seed * 16807) % 1000
            return (_seed + 1) / 1000
        },
    },
}
